function getFile(data){
    return window.axios.post('/api/socios/export', data ,{ responseType: 'blob' });
}
export default {
    getFile
}